var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { C } from '#integrations';
import { useToastService } from '../../context';
import { lastNToasts } from '../../services';
import { DISPLAY_TOASTS_COUNT } from '../../Toast.constants';
import { Toast } from '../Toast';
import styles from './ToastContainer.module.css';
export const ToastContainer = () => {
    _react_refresh_temp_2();
    const containerRef = useRef(null);
    const { setToastContainer, toasts } = useToastService();
    useEffect(() => {
        setToastContainer(containerRef.current);
    }, [setToastContainer]);
    return (_jsx("div", { className: C(styles.Container, toasts.length === 0 && styles.NoContent), popover: "manual", ref: containerRef, children: lastNToasts(DISPLAY_TOASTS_COUNT, toasts).map((toast) => (_jsx(Toast, { "data-testid": toast['data-testid'], toast: toast }, toast.id))) }));
};
_react_refresh_temp_1 = ToastContainer;
$RefreshReg$(_react_refresh_temp_1, "ToastContainer");
_react_refresh_temp_2(ToastContainer, "yQT/CWQmJi7V3isydWu5a9VT5ig=", false, () => [useToastService]);
